const headers = {
  name: "Home",
  navigate: {
    path: [
      {
        name: "Home",
        path: "/app/home",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
